import { createPromise } from "common/promises";
import log from "loglevel";
import * as PIXI from "pixi.js";
import * as R from "ramda";
import { AnimatedSpriteWrap } from "./pixi/animatedSprite";
/**
 * 로딩된 Sprite Sheet에 대응되는 클래스
 * animation, animationTexture, textures, sprite, sprites와 같은
 * 함수들을 사용해 PIXI Texture와 Sprite를 생성하는 용도
 */
export class Sheet {
    constructor(sheet) {
        this.sheet = sheet;
    }
    static async load(imagePath, dataPath) {
        const texture = await loadTexture(imagePath);
        const sheetData = await loadData(dataPath);
        const sheet = new PIXI.Spritesheet(texture, sheetData);
        const { promise, resolve } = await createPromise();
        sheet.parse(resolve);
        await promise;
        return new Sheet(sheet);
    }
    hasAnimation(name) {
        return this.sheet.animations[name] != null;
    }
    animationTextureNames(name) {
        // let result: string[] = [];
        if (this.sheet.data.animations != null &&
            this.sheet.data.animations[name] != null) {
            return this.sheet.data.animations[name];
        }
        return [];
        // for (const anim of this.sheet.animations[name]) {
        //   result = result.concat(anim.textureCacheIds);
        // }
        // return result;
        // return this.sheet.animations[name].map((anim) => anim.textureCacheIds);
    }
    /**
     * 애니메이션 텍스쳐들을 바탕으로 애니메이션 스프라이트 생성
     */
    animation(pixiContext, name) {
        if (this.sheet.animations[name] == null) {
            log.error("can't find animation", name, this.sheet.animations[name], this.sheet.animations);
        }
        const sprite = new AnimatedSpriteWrap(pixiContext, this.sheet.animations[name]);
        sprite.anchor.set(0.5, 0.5);
        return sprite;
    }
    // animationTextures(name: string): PIXI.Texture[] {
    //   if (this.sheet.animations[name] == null) {
    //     return [];
    //   }
    //   return this.sheet.animations[name];
    // }
    // animationTexturesWithName(name: string): [string, PIXI.Texture][] {
    //   if (this.sheet.animations[name] == null) {
    //     return [];
    //   }
    //   const textureNames = this.sheet.data.animations[name];
    //   return map((name) => [name, this.sheet.textures[name]], textureNames);
    // }
    textures(names) {
        const textures = names.map((name) => this.sheet.textures[name]);
        return R.filter((texture) => texture != null, textures);
    }
    texturesWithName(names) {
        const textures = names.map((name) => [
            name,
            this.sheet.textures[name],
        ]);
        return R.filter(([_, texture]) => texture != null, textures);
    }
    sprite(name) {
        return this.sprites([name])[0];
    }
    sprites(names) {
        const textures = this.textures(names);
        return textures.map((texture) => {
            const sprite = new PIXI.Sprite(texture);
            sprite.anchor.set(0.5, 0.5);
            return sprite;
        });
    }
}
async function loadTexture(imagePath) {
    const texture = PIXI.Texture.from(imagePath);
    const { promise, resolve } = await createPromise();
    texture.baseTexture.once("loaded", resolve);
    if (texture.valid) {
        // FIXME: please de subscribe loaded event
        return texture;
    }
    await promise;
    return texture;
}
async function loadData(dataPath) {
    const { promise, resolve, reject } = await createPromise();
    $.ajax({
        url: dataPath,
        dataType: "json",
    })
        .done(resolve)
        .fail(reject);
    const response = await promise;
    console.log(response);
    return response;
}
//# sourceMappingURL=sheet.js.map